import { render, staticRenderFns } from "./CreditInvoiceOverview.vue?vue&type=template&id=6790659a"
import script from "./CreditInvoiceOverview.vue?vue&type=script&lang=js"
export * from "./CreditInvoiceOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports